let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("djb49")).then(() => parcelRequire('4tVXT'));